import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/PressAnnouncements.css';

const PressAnnouncements = () => {
  return (
    <>
      <Helmet>
        <title>Press Announcements - Latest Company News & Updates | Redbox Global</title>
        <meta name="description" content="Stay informed with Redbox Global's latest press announcements, corporate news, product launches, partnerships, and significant milestones in financial technology and data services." />
        <meta name="keywords" content="press announcements, press releases, company news, corporate announcements, Redbox Global news, financial technology news, product launches, partnerships, business updates, media announcements" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/press-announcements" />
        <meta property="og:title" content="Press Announcements - Latest Company News | Redbox Global" />
        <meta property="og:description" content="Stay updated with Redbox Global's latest press announcements, product launches, partnerships, and corporate milestones." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/press-announcements" />
        <meta name="twitter:title" content="Press Announcements - Latest Company News | Redbox Global" />
        <meta name="twitter:description" content="Latest press releases and corporate announcements from Redbox Global." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/press-announcements" />
        <meta name="news_keywords" content="financial technology, press release, corporate news, business announcements" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Press Announcements",
            "description": "Latest press announcements and corporate news from Redbox Global.",
            "url": "https://redboxglobal.com/press-announcements",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global",
              "logo": {
                "@type": "ImageObject",
                "url": "https://redboxglobal.com/logo.png"
              },
              "url": "https://redboxglobal.com"
            },
            "mainEntity": {
              "@type": "ItemList",
              "itemListElement": [
                {
                  "@type": "NewsArticle",
                  "position": 1,
                  "headline": "Redbox Global Launches Next-Generation Financial Data Platform",
                  "description": "Revolutionary AI-powered platform transforming how financial institutions access and analyze market data.",
                  "url": "https://redboxglobal.com/article/next-gen-data-platform"
                }
              ]
            }
          })}
        </script>
      </Helmet>
      
     <div className="page-container">
        <div className="page-header">
          <h1>Press Announcements</h1>
          <p className="page-subtitle">
            Official updates, milestones, and corporate news from Redbox Global
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a 
            href="/press/redbox-global-expansion-2026" 
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img 
                  src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&h=600&fit=crop" 
                  alt="Corporate Expansion" 
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Featured Release</span> */}
                <h2>Redbox Global Announces Strategic International Expansion</h2>
                <p>
                  Redbox Global unveils plans for global expansion in 2026, 
                  strengthening its presence across Europe, Asia, and the Middle East.
                </p>
                <span className="article-meta">February 10, 2026</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">

            <a 
              href="/press/new-executive-appointment" 
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img 
                    src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=600&h=400&fit=crop" 
                    alt="Executive Appointment" 
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Leadership</span> */}
                  <h2>Redbox Global Appoints New Chief Strategy Officer</h2>
                  <p>
                    Industry veteran joins Redbox Global to drive innovation and 
                    long-term strategic growth.
                  </p>
                  <span className="article-meta">February 6, 2026</span>
                </div>
              </article>
            </a>

            <a 
              href="/press/strategic-partnership-announcement" 
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img 
                    src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&h=400&fit=crop" 
                    alt="Strategic Partnership" 
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Partnership</span> */}
                  <h2>Redbox Global Forms Strategic Alliance with Global Media Firm</h2>
                  <p>
                    A landmark collaboration designed to enhance digital reach and 
                    premium content distribution.
                  </p>
                  <span className="article-meta">February 4, 2026</span>
                </div>
              </article>
            </a>

            <a 
              href="/press/annual-performance-report-2025" 
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img 
                    src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop" 
                    alt="Annual Report" 
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Corporate Report</span> */}
                  <h2>Redbox Global Reports Strong 2025 Annual Performance</h2>
                  <p>
                    Company posts record growth, highlighting expansion, innovation, 
                    and sustained profitability.
                  </p>
                  <span className="article-meta">February 1, 2026</span>
                </div>
              </article>
            </a>

          </div>
        </div>
      </div>
    </>
  );
};

export default PressAnnouncements;
